export { default as HomeTemplate } from './HomeTemplate';
export { default as NotFoundTemplate } from './NotFoundTemplate';
export { default as DisplayErrorTemplate } from './DisplayErrorTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/root/pages/index.js